import React, {useEffect, useState} from 'react';
import web2barcode from '../../img/Logo.png';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from './windowsDimensions';
import {
    Link
} from "react-router-dom";
import { codalyUrl } from '../codaly/CodalyPromo';

const HeaderHome = ({setCuenta}) => {

    const { width }           = useWindowDimensions();
    const { t }               = useTranslation();
    const [drops, setdrops]   = useState(false);
    useEffect(() => {
        if(width >= 992){
            setdrops(true);
        }else{
            setdrops(false);
        }
    }, [width])


  return (
    <div className="fixed-top">
        {/* Barra de anuncio de Codaly */}
        <a
            href={codalyUrl('/designer', 'header')}
            target="_blank"
            rel="noopener noreferrer"
            className="cdl-announce"
        >
            <strong>Nuevo:</strong> web2barcode ahora es Codaly. Prueba el nuevo diseñador de etiquetas
            <span className="cdl-announce-cta">Abrir diseñador →</span>
        </a>

        <nav className="navbar navbar-expand-lg navbar-light px-5 border-bottom border-secondary" style={{backgroundColor: '#44ab53'}}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/" onClick={() => setCuenta(0)}>
                    <img src={web2barcode} className='img-fluid border rounded' width={80}/>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse align-items-center" id="navbarNavAltMarkup">
                    <div className="navbar-nav me-auto mb-2 mb-lg-0">

                    </div>

                    <div style={{marginRight: '5rem'}} className={`${drops ? "mt-0" : "mt-3"}`}>
                        <button
                            onClick={() => setCuenta(1)}
                            className='btn btn-primary fw-bold text-uppercase border'>
                            { t("main.login") }
                        </button>
                    </div>

                </div>
            </div>
        </nav>
    </div>
  )
}

export default HeaderHome
